import { apiClient } from "./api";
export const missionService = {
    getAll: async (filters) => {
        const params = new URLSearchParams();
        if (filters?.status)
            params.append("status", filters.status);
        if (filters?.drone_id)
            params.append("drone_id", filters.drone_id);
        if (filters?.site)
            params.append("site", filters.site);
        if (filters?.limit)
            params.append("limit", filters.limit.toString());
        if (filters?.offset)
            params.append("offset", filters.offset.toString());
        const queryString = params.toString();
        const response = await apiClient.get(`/missions/${queryString ? `?${queryString}` : ""}`);
        return response.data;
    },
    getById: async (id) => {
        const response = await apiClient.get(`/missions/${id}/`);
        return response.data.data;
    },
    create: async (data) => {
        const response = await apiClient.post("/missions/", data);
        return response.data.data;
    },
    update: async (id, data) => {
        const response = await apiClient.patch(`/missions/${id}/`, data);
        return response.data.data;
    },
    delete: async (id) => {
        await apiClient.delete(`/missions/${id}/`);
    },
    start: async (id) => {
        const response = await apiClient.post(`/missions/${id}/start/`);
        return response.data.mission;
    },
    pause: async (id) => {
        const response = await apiClient.post(`/missions/${id}/pause/`);
        return response.data.mission;
    },
    resume: async (id) => {
        const response = await apiClient.post(`/missions/${id}/resume/`);
        return response.data.mission;
    },
    abort: async (id) => {
        const response = await apiClient.post(`/missions/${id}/abort/`);
        return response.data.mission;
    },
    getStats: async () => {
        const response = await apiClient.get("/missions/stats/");
        return response.data;
    },
    getTelemetry: async (missionId, limit = 1) => {
        const response = await apiClient.get(`/missions/${missionId}/telemetry/?limit=${limit}`);
        return response.data;
    },
    getAllTelemetry: async (missionId) => {
        const response = await apiClient.get(`/missions/${missionId}/telemetry/?limit=10000`);
        return response.data;
    },
};
